import { $authHost } from "../../http";
import { 
    CURRENCY_GET_REQUEST, CURRENCY_GET_SUCCESS, CURRENCY_GET_ERROR, 
    CURRENCY_GET_BY_KEY_REQUEST, CURRENCY_GET_BY_KEY_SUCCESS, CURRENCY_GET_BY_KEY_ERROR, 
    CURRENCY_ADD_REQUEST, CURRENCY_ADD_SUCCESS, CURRENCY_ADD_ERROR, 
    CURRENCY_EDIT_REQUEST, CURRENCY_EDIT_SUCCESS, CURRENCY_EDIT_ERROR, 
    CURRENCY_DELETE_REQUEST, CURRENCY_DELETE_SUCCESS, CURRENCY_DELETE_ERROR
} from "../constants/currencyConstants";

export const getCurrencies = (args) => async (dispatch) => {
    try {
        dispatch({
            type: CURRENCY_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/currency/query",
            args || {},
            config,
        );
        dispatch({
            type: CURRENCY_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: CURRENCY_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getCurrencyByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: CURRENCY_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/currency/${id}`,
        );
        dispatch({
            type: CURRENCY_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: CURRENCY_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addCurrency = ({ name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: CURRENCY_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/currency",
            { name, code, description },
            config,
        );
        dispatch(getCurrencies(queryArgs || {}));
        dispatch({
            type: CURRENCY_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: CURRENCY_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editCurrency = ({ id, name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: CURRENCY_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/currency",
            { id, name, code, description },
            config,
        );
        dispatch(getCurrencies(queryArgs || {}));
        dispatch({
            type: CURRENCY_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: CURRENCY_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteCurrency = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: CURRENCY_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/currency",
            { data: { id } },
            config,
        );
        dispatch(getCurrencies(queryArgs || {}));
        dispatch({
            type: CURRENCY_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: CURRENCY_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

